import { TDropItem } from 'src/types';

export const unitOptions: TDropItem[] = [
  { value: '', label: 'Choose Unit' },
  { value: 'feet', label: 'Feet' },
  { value: 'meters', label: 'Meters' },
  { value: 'miles', label: 'Miles' },
  { value: 'kilometers', label: 'Kilometers' },
];
